/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type AssignClientBadRequestErrorCode = (typeof AssignClientBadRequestErrorCode)[keyof typeof AssignClientBadRequestErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssignClientBadRequestErrorCode = {
  client_not_local: "client_not_local",
  client_not_synced_to_blogic: "client_not_synced_to_blogic",
  client_not_allowed: "client_not_allowed",
  analysis_already_exists_for_client: "analysis_already_exists_for_client",
  nsure_self_dealing_forbidden: "nsure_self_dealing_forbidden",
} as const;
